/* Vitafy | Product photo comparison (preview only).
 * Se activa exclusivamente cuando la URL contiene ?vf_photo=uso
 * y la PDP corresponde a la rodillera.
 * Sin aleatorización ni recolección automática: NO es un test A/B en vivo.
 * No altera las imágenes del catálogo ni las selecciones de packs/variantes.
 */
(function () {
 'use strict';
 if (!window.URLSearchParams) return;
 var variant = new URLSearchParams(window.location.search).get('vf_photo');
 if (variant !== 'uso') return;
 function activate(root) {
   var info=(root || document).querySelector('product-info[data-vf-photo-target]');
   if (!info || info.dataset.vfPhotoActivated === 'yes') return;
   var mediaId=info.dataset.vfPhotoTarget;
   var gallery=info.querySelector('media-gallery');
   if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
   if (!gallery.querySelector('[data-media-id="'+ mediaId +'"]')) return;
   info.dataset.vfPhotoActivated='yes';
   gallery.setActiveMedia(mediaId, true);
 }
 if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded',function(){activate(document)},{once:true});
 } else {
   activate(document);
 }
 document.addEventListener('shopify:section:load',function(e){activate(e.target)});
})();
